import * as UntitledUiIcons from '@untitled-ui/icons-react';
import CountryFlag from 'react-country-flag';
import CommendaIcons from './CommendaIcons';
import FeaturedIcon from './FeaturedIcon';
import PaymentIcons from './PaymentIcons';
import SoftwareIcons from './SoftwareIcons';

// Define a more explicit type for IconsType
type IconsType = {
  [key in keyof typeof UntitledUiIcons]: (typeof UntitledUiIcons)[key];
} & typeof PaymentIcons &
  typeof CommendaIcons;

// Create the Icons object with the defined type
const Icons: IconsType = {
  ...UntitledUiIcons,
  ...PaymentIcons,
  ...CommendaIcons,
};

export { FileTypeIcon } from './FileTypeIcons';

// Export the necessary components
export { CountryFlag, FeaturedIcon, SoftwareIcons, Icons };
